import LoginForm from './LoginForm';
import RecoverPasswordForm from './RecoverPasswordForm';
import { SignInParams } from './Types';
import { validateSignInParams } from './Validator';
import ConfirmForgotPasswordForm from './ConfirmForgotPasswordForm';

const SignIn = (params: SignInParams): JSX.Element => {
  validateSignInParams(params);
  const { forgotPassword, recoverPasswordSuccess } = params;

  if (forgotPassword) {
    if (recoverPasswordSuccess) {
      return ConfirmForgotPasswordForm(params);
    }
    return RecoverPasswordForm(params);
  }
  return LoginForm(params);
};

export default SignIn;
